import React, { useCallback } from 'react';
import { fetchDBUDataWithFiltersData } from 'service/service';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';

/**
 * ComputeSpendTable component refactored to use AdbFlatTableBase.
 */
const ComputeSpendTable = () => {
  const serviceFunc = useCallback((params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, selectedDateInString, exportType,
      sortBy, sortDir
    } = params;
    return fetchDBUDataWithFiltersData({
      startDate,
      endDate,
      env,
      sector,
      location,
      page,
      pageSize,
      filters: apiFilters,
      selectedDateInString,
      workspaceName: undefined,
      exportType,
      sortField: sortBy,
      sortOrder: sortDir
    });
  }, []);

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Compute Spend Details"
      breadcrumbLabel="Workspace Overview"
      breadcrumbPath="/databricksADB/workspace"
      tableType="compute-spend-table"
      preserveFilterKey="compute_spend_table"
      hideComputeType={true}
    />
  );
};

export default ComputeSpendTable;